export const PERMISSIONS = {
  STORE_SAP_CONFIG_EDIT: 'store:sap_config:edit',
  AGGREGATOR_SAP_CONFIG_EDIT: 'aggregator:sap_config:edit',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
